import React from 'react';
import Styled from 'styled-components';
import { useDispatch } from 'react-redux';
import Icon, { COLORS, ICONS } from '../icon';
import { setActiveTab, setRightDrawerOpen } from '../../../stores/actions/tabs';
import { TABS } from '../../../stores/types/tabs';

interface TitleProps {
	title: string | JSX.Element; // can be an interactable element
	classNamesExtra?: string; // css classes
	badge?: JSX.Element; // badge to display (currently only shots drawer)
	alignBadge?: 'left' | 'right'; // align badge to left or right, default right
	testid?: string;
	// used to "go back" a drawer (currently only generated content sub drawer)
	backButtonFunction?: Function;
	showXButton?: boolean;
	xButtonFunction?: () => void;
}

const HeaderWrapper = Styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin: 24px 24px 8px 24px;

	.header-text {
		flex: 1;
	}

	.next-countdown {
		color: var(--primitives-mode-1-gray-300);
	}

	.header-status {
		padding: 0 18px 0 12px;
	}

	p {
		font-size: 16px;
		font-weight: 800;
	}

	.header-back-button {
		cursor: pointer;
		margin-right: 8px;
		line-height: 0;
	}
`;

export default function Heading(props: TitleProps) {
	const {
		title,
		classNamesExtra,
		badge = <></>,
		alignBadge = 'right',
		testid = '',
		backButtonFunction = null,
		showXButton = true,
		xButtonFunction = () => {
			dispatch(setRightDrawerOpen(false));
			dispatch(setActiveTab(TABS.NONE));
		}
	} = props;

	const dispatch = useDispatch();

	const alignBadgeCss = alignBadge === 'left' ? { marginRight: 'auto' } : { marginLeft: 'auto' };

	return (
		<HeaderWrapper
			data-testid={testid}
			className={classNamesExtra}
		>
			{backButtonFunction
				? <button onClick={() => backButtonFunction()} className='header-back-button transparent'>
					<Icon name={ICONS.ARROW_LEFT} color={COLORS.TEXT_GRAY_200} size={16} />
				</button>
				: <></>}

			<h5 className='bl-font-header' style={{ margin: '1px 8px -1px 0' }}>
				{title}
			</h5>

			<div style={alignBadgeCss}>
				{badge}
			</div>

			{showXButton ? <button
				className={'button-close transparent'}
				onClick={xButtonFunction}
			>
				<Icon name={ICONS.CLOSE} color={COLORS.DARK_GRAY_2} size={16} />
			</button> : null}
		</HeaderWrapper>
	);
}
